import React from "../../../../__snowpack__/pkg/react.js";
import {Tooltip, Space} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {EditOutlined, DeleteOutlined} from "../../../../__snowpack__/pkg/@ant-design/icons.js";
export default function index(props) {
  const {formatMessage} = useIntl();
  const {onEdit, onDelete} = props;
  return /* @__PURE__ */ React.createElement(Space, null, onEdit && /* @__PURE__ */ React.createElement(Tooltip, {
    title: formatMessage({id: "massEdit"})
  }, /* @__PURE__ */ React.createElement(EditOutlined, {
    style: {fontSize: "14px", cursor: "pointer"},
    onClick: onEdit
  })), onDelete && /* @__PURE__ */ React.createElement(Tooltip, {
    title: formatMessage({id: "emptyMass"})
  }, /* @__PURE__ */ React.createElement(DeleteOutlined, {
    style: {fontSize: "14px", cursor: "pointer"},
    onClick: onDelete
  })));
}
